import type { IconSvgObject } from './types';

const BluetoothNotConnectedIcon: IconSvgObject = [
  ["path", { d: "M17.502 17.5L12.0014 21L12 12L6 17M12.0014 8V3L18 6.99997L14.502 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BluetoothNotConnectedIcon;
